import React from "react";
import Resources from "../../../types/Resources";
import { permitPageUrl } from "../../../common/permitUtils";
import { PermitDocument } from "../../../types/permits";

type RenewalInfoProps = {
    permitDocument: PermitDocument;
    resources: Resources;
};

function hasRenewalOfPermit(permitDocument: any): permitDocument is {
    renewalOfPermitSequenceIdentifier: string;
    initialStartDate: Date;
} {
    return !!permitDocument.renewalOfPermitSequenceIdentifier && !!permitDocument.initialStartDate;
}

function hasRenewedByPermit(permitDocument: any): permitDocument is {
    renewedByPermitSequenceIdentifier: string;
    extendedEndDate: Date;
} {
    return !!permitDocument.renewedByPermitSequenceIdentifier && !!permitDocument.extendedEndDate;
}

function RenewalInfo(props: RenewalInfoProps) {
    return (
        <div>
            {hasRenewalOfPermit(props.permitDocument) ? (
                <div className="mb-2">
                    <div>
                        <span className="fw-bold me-1">{props.resources.get("RenewalOf")}:</span>
                        <a
                            href={permitPageUrl({
                                permitType: props.permitDocument.permitName,
                                sequenceIdentifier: props.permitDocument.renewalOfPermitSequenceIdentifier,
                                departmentId: props.permitDocument.departmentId
                            })}
                        >
                            {props.permitDocument.renewalOfPermitSequenceIdentifier}
                        </a>
                    </div>
                    <div>
                        <span className="fw-bold me-1">{props.resources.get("InitialStartDate")}:</span>
                        <span>{props.permitDocument.initialStartDate.toLocaleDateString()}</span>
                    </div>
                </div>
            ) : null}
            {hasRenewedByPermit(props.permitDocument) ? (
                <div>
                    <div>
                        <span className="fw-bold me-1">{props.resources.get("RenewedBy")}:</span>
                        <a
                            href={permitPageUrl({
                                permitType: props.permitDocument.permitName,
                                sequenceIdentifier: props.permitDocument.renewedByPermitSequenceIdentifier,
                                departmentId: props.permitDocument.departmentId
                            })}
                        >
                            {props.permitDocument.renewedByPermitSequenceIdentifier}
                        </a>
                    </div>
                    <div>
                        <span className="fw-bold me-1">{props.resources.get("ExtendedEndDate")}:</span>
                        <span>{props.permitDocument.extendedEndDate.toLocaleDateString()}</span>
                    </div>
                </div>
            ) : null}
        </div>
    );
}

export default RenewalInfo;
